'use strict';

// http://262.ecma-international.org/5.1/#sec-9.2

module.exports = function ToBoolean(value) { return !!value; };



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/2024/ToBoolean.js
 ** module id = 1057
 ** module chunks = 0
 **/